import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { ModuleMenu, INSTRUCTION } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsSummaryService } from '../../../services/grants/grants-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-user-instructions-modal',
  templateUrl: './ist-user-instructions-modal.component.html',
  styleUrls: ['./ist-user-instructions-modal.component.scss']
})
export class IstUserInstructionsModalComponent implements OnInit {

  id: number;
  isAck = false;
  menudata: ModuleMenu;
  instruction: INSTRUCTION;
  title: string = "";
  description: string = "";
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private dataShare: IstDataShareService,
    private header: HeadService,
    private commonService: CommonService,
    private summaryService: GrantsSummaryService,
  ) { }

  ngOnInit() {
    this.getGrantsInstructions();
  }

  add() {
    this.commonService.removeLeftMenu();
    this.modalRef.dismiss();
    this.dataShare.setApplicationID("");
    this.commonService.appId = "";
    this.commonService.ScreenID = "";
    this.commonService.setISTApp(null);
    this.menudata = new ModuleMenu();
    this.menudata.module = "IST";
    this.menudata.operation = "New";
    this.menudata.appId = "";
    this.menudata.formstate = "Draft";
    this.menudata.screenID = "";
    this.commonService.setModluleMenu(this.menudata);
    this.header.setHeader(this.menudata);
    this.router.navigate(['/home/ist/my-applications/application-ext/:0/general_information_request'], {skipLocationChange:true, queryParams:{id:"", app_ext:true, module:"ist",submodule:"ist", screen_type:"my-applications" }});
  }
  isChecked($event){
    this.isAck = !this.isAck;
  }
  getGrantsInstructions() {
    let instructionid = "2"
    this.summaryService.getInstruction(instructionid).subscribe(summary => {
      this.instruction = summary;
      if (this.instruction != null) {
        this.title = this.instruction.NAME;
        this.description = this.instruction.DESCRIPTION;
      }

    });
  }
}
